<template lang="pug">
  div#role-history-timeline.role-history-timeline(
    v-if="history.length"
    v-scroll:#role-history-timeline="onScroll"
    :style="{ '--timelineHeight': 47 * history.length + (history.length > 0 ? 20 : 0) + 'px' }"
  )
    v-layout.pt-2.column(v-for="action in history" :key="action.role_id")
      v-flex.xs4
        span.caption {{ displayDate(action.creation_date) }}
      //- v-flex(:class="action.role_history_action === 'DELETE_RC_ROLE' ? 'error--text' : 'success--text'")
        v-icon.pr-2(small v-if="action.product_name" :color="action.role_history_action === 'DELETE_RC_ROLE' ? 'error' : 'success'") {{ action.role_history_action === 'DELETE_RC_ROLE' ? 'remove' : 'add' }}
        strong {{action.product_name}}
      v-flex.pl-3.caption
        span  
          b Le rôle "
          span(v-if="!!action.product_name") {{ action.product_name }} :
          span  {{ action.role_name }}"
          span  
            b  a été
          span(v-if="action.role_history_action === 'DELETE_RC_ROLE'")
            b  retiré par : 
          span(v-if="action.role_history_action === 'INSERT_RC_ROLE'")
            b  ajouté par : 
          span  "{{ action.writer_login }}"
  v-layout.justify-center.pt-5.px-5.font-italic.text-xs-center.subheading.grey--text.text--darken-2(v-else style="height: 300px;")
    |L'historique des rôles est vide
</template>

<script>
export default {
  props: {
    history: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      size: 50,
    };
  },
  methods: {
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    fromNow(date) {
      const displayDate = this.$moment(date).tz('Europe/Paris').locale('fr').fromNow();
      return displayDate === 'Invalid date' ? null : this.capitalize(displayDate);
    },
    displayDate(date) {
      const displayDate = this.$moment(date).tz('Europe/Paris').locale('fr').format('LLLL');
      return displayDate === 'Invalid date' ? null : this.capitalize(displayDate);
    },
    onScroll(e) {
      if (e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight) {
        this.size += 50;
        this.$emit('scrollDown');
      }
    },
  },
};
</script>

<style lang="scss">
  .role-history-timeline {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    &::before {
      height: var(--timelineHeight);
    }
  }
</style>
